import {
  initialState,
  FETCH_CLIENT_DATA,
  FETCH_CLIENT_DATA_SUCCESS,
  FETCH_CLIENT_DATA_FAIL,
  UPDATE_CLIENT_DATA,
  ClientDataDispatchTypes,
  IClientDataState,
} from '.'

export const clientDataReducer = (state = initialState, action: ClientDataDispatchTypes): IClientDataState => {
  switch (action.type) {
    case FETCH_CLIENT_DATA:
      return {
        ...state,
        error: null,
        isLoading: true,
      }
    case FETCH_CLIENT_DATA_SUCCESS:
      return {
        ...state,
        error: null,
        data: action.payload,
        isLoading: false,
      }
    case FETCH_CLIENT_DATA_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    case UPDATE_CLIENT_DATA:
      return {
        ...state,
        error: null,
        data: action.payload,
      }

    default:
      return state
  }
}
